import { Component, OnInit, inject } from '@angular/core';
import { UIService } from '../+shared/+state/ui/ui.service';
import { AdminFooterComponent } from './+shared/components/admin-footer/admin-footer.component';
import { RouterOutlet } from '@angular/router';
import { AdminNavBarComponent } from './+shared/components/admin-nav-bar/admin-nav-bar.component';

@Component({
    selector: 'dish-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    imports: [
        AdminNavBarComponent,
        AdminFooterComponent,
    ]
})
export class AdminComponent implements OnInit {
  private uiService = inject(UIService);


  ngOnInit() {
    this.uiService.hideLoader();
  }
}
